<template>
  <div class="content-box">
    <div class="bg">
      <img src="../../assets/images/share_error_1.svg" alt="" />
    </div>
    <div class="box">
      <div class="title">该条分享信息已过期</div>
      <img
        class="empty-img"
        src="../../assets/images/share_error_2.svg"
        alt=""
      />
      <div class="msg">
        <div>如果您有业务方面的需求，</div>
        <div>
          可致电活动联系人陈老师（电话：<a
            href="tel: 18080079892"
            style="color: #A30903"
          >
            18080079892</a
          >）。
        </div>
      </div>
    </div>

    <div class="footer">
      <img
        class="empty-img"
        src="../../assets/images/share_error_3.svg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { errorShareMsg } from "@/config";
export default {
  name: "ErrorExpired",
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.content-box {
  padding: 160px 0 0;
  background: #f3f3f3;
  color: rgba(0, 0, 0, 0.9);
  position: relative;
  z-index: 2;
  height: calc(100vh - 160px);
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;
    width: 100%;
    img {
      width: 100%;
      object-fit: contain;
    }
  }
  .box {
    margin: 10px;
    border-radius: 16px;

    background: linear-gradient(180deg, #fbfbfc 27%, #fbfbfc 100%);
    padding: 35px 30px;
    text-align: center;
    .title {
      font-size: 22px;
      font-family: "PingFang SC-Semibold, PingFang SC";
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 26px;
    }
    .empty-img {
      width: 180px;
      object-fit: contain;
      margin: 45px auto 20px;
    }
    .msg {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 14px;
    }
  }
  .footer {
    width: 100%;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.4);
    line-height: 60px;
    text-align: center;
    position: absolute;
    bottom: 0;
    left: 0;
    background: #f3f3f3;
    height: 60px;
  }
}
</style>